import { addListener, createListenerMiddleware, TypedAddListener, TypedStartListening } from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from './store';

// Create the middleware instance and methods
export const listenerMiddleware = createListenerMiddleware();

// Create pre-defined Listener Middleware types:
// https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;
